import { useContext } from 'react';
import TraLockContext, {
    type TRALockContextValues,
} from '../contexts/TraLockContext';

export default function useTRALock(): TRALockContextValues {
    const context = useContext(TraLockContext);
    if (context === undefined) {
        throw new Error('useTraLock must be used within a TraProvider');
    }
    return context;
}
